import * as fetch from '../../../utils/action'
import { getTotalNumber, downloadFilename } from '../totalMethod'
import timeutils from 'utils/wt-time-utils'
import mallDatas from '../datas/mall'
import { workOrderType } from 'json/mall-options'
import { getEnumeration } from 'enumeration'
import { organizationRoleType } from 'json/customer-options'
export default {
  createdGoodsDraft (ctx, data) {
    return fetch.createdGoodsDraft(data).then(res => {
      return res.data
    })
  },
  // 根据商品归属查询商品类型列表
  getGoodsTypeList (ctx, data) {
    return fetch.getGoodsTypeList(data).then(res => {
      return res.data
    })
  },
  goodsList (ctx, data) {
    return fetch.goodsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  salesGoodsList (ctx, data) {
    return fetch.goodsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  goodsDetail (ctx, id) {
    return fetch.goodsDetail(id).then(res => {
      let result = res.data
      result = mallDatas.goodsDetail(result, true)
      return result
    })
  },
  salesGoodsDetail (ctx, id) {
    return fetch.salesGoodsDetail(id).then(res => {
      let result = res.data
      result = mallDatas.goodsDetail(result)
      return result
    })
  },
  goodsDelete (ctx, id) {
    return fetch.goodsDelete(id).then(res => {
      return res.data
    })
  },
  goodsRecommend (ctx, id) {
    return fetch.goodsRecommend(id).then(res => {
      return res.data
    })
  },
  goodsRecommendCancel (ctx, id) {
    return fetch.goodsRecommendCancel(id).then(res => {
      return res.data
    })
  },
  updateRanking (ctx, data) {
    return fetch.updateRanking(data).then(res => {
      return res.data
    })
  },
  goodsPublish (ctx, data) {
    return fetch.goodsPublish(data).then(res => {
      return res.data
    })
  },
  applyForApproval (ctx, id) {
    return fetch.applyForApproval(id).then(res => {
      return res.data
    })
  },
  approvalReject (ctx, id) {
    return fetch.approvalReject(id).then(res => {
      return res.data
    })
  },
  getGoodsGroup (ctx, data) {
    return fetch.getGoodsGroup(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  goodsOffShelves (ctx, id) {
    return fetch.goodsOffShelves(id).then(res => {
      return res.data
    })
  },
  newGoodsGroup (ctx, data) {
    return fetch.newGoodsGroup(data).then(res => {
      return res.data
    })
  },
  goodsGroupDetail (ctx, id) {
    return fetch.goodsGroupDetail(id).then(res => {
      return res.data
    })
  },
  groupEdit (ctx, data) {
    return fetch.groupEdit(data).then(res => {
      return res.data
    })
  },
  getDetectionPackageEntities (ctx, data) {
    return fetch.getDetectionPackageEntities(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getDetectionPackageEntities(result.data)
      return result
    })
  },
  shippingAddress (ctx, id) {
    return fetch.shippingAddress(id).then(res => {
      let result = res.data
      return result
    })
  },
  creatDeliverGoodsDetail (ctx, data) {
    return fetch.creatDeliverGoodsDetail(data).then(res => {
      return res
    })
  },
  applyForRefundment (ctx, data) {
    return fetch.applyForRefundment(data).then(res => {
      return res
    })
  },
  approvalRefundment (ctx, data) {
    return fetch.approvalRefundment(data).then(res => {
      return res
    })
  },
  // 获取优惠劵列表
  getCouponsList (ctx, data) {
    return fetch.getCouponsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getCouponsList(result.data)
      return result
    })
  },
  createCoupons (ctx, data) {
    return fetch.createCoupons(data).then(res => {
      let result = res.data
      return result
    })
  },
  saveCoupons (ctx, data) {
    return fetch.saveCoupons(data).then(res => {
      let result = res.data
      return result
    })
  },
  couponDetail (ctx, data) {
    return fetch.couponDetail(data).then(res => {
      let result = res.data
      result = mallDatas.couponDetail(result)
      return result
    })
  },
  couponEdit (ctx, data) {
    return fetch.couponEdit(data).then(res => {
      let result = res.data
      return result
    })
  },
  coupontDelete (ctx, id) {
    return fetch.coupontDelete(id).then(res => {
      let result = res.data
      return result
    })
  },
  couponUpdateStatus (ctx, data) {
    return fetch.couponUpdateStatus(data).then(res => {
      let result = res.data
      return result
    })
  },
  downloadPrivateResource (ctx, data) {
    return fetch.downloadPrivateResource(data).then(res => {
      return res.data
    })
  },
  createPromotion (ctx, data) {
    return fetch.createPromotion(data).then(res => {
      return res.data
    })
  },
  getPromotionList (ctx, data) {
    return fetch.getPromotionList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getPromotionList(result.data)
      return result
    })
  },
  // 促销活动详情
  promotionDetail (ctx, data) {
    return fetch.promotionDetail(data).then(res => {
      let result = mallDatas.promotionDetail(res.data)
      return result
    })
  },
  // 删除促销活动
  promotionDelete (ctx, id) {
    return fetch.promotionDelete(id).then(res => {
      return res.data
    })
  },
  // 更改促销活动状态
  promotionStatus (ctx, data) {
    return fetch.promotionStatus(data).then(res => {
      return res.data
    })
  },
  // 编辑促销活动
  promotionEdit (ctx, data) {
    return fetch.promotionEdit(data).then(res => {
      return res.data
    })
  },
  technologyCycle (ctx, type) {
    return fetch.technologyCycle(type).then(res => {
      let result = mallDatas.technologyCycle(res.data)
      return result
    })
  },
  groupDelete (ctx, id) {
    return fetch.groupDelete(id).then(res => {
      return res.data
    })
  },
  // 获取商城用户
  getMallUser (ctx, data) {
    return fetch.getMallUser(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getMallUser(result.data)
      return result
    })
  },
  // 后台商品分组，商品列表排序接口
  goodsSort (ctx, data) {
    return fetch.goodsSort(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  salesGoodsSort (ctx, data) {
    return fetch.salesGoodsSort(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsList(result.data)
      return result
    })
  },
  // 获取广告位列表
  getBannerList (ctx, data) {
    return fetch.getBannerList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  // 获取所有的广告位定义
  bannersPositions (ctx, data) {
    return fetch.bannersPositions(data).then(res => {
    //   let result = getTotalNumber(res)
      let result = mallDatas.bannersPositions(res.data)
      return result
    })
  },
  // 替换指定位置上的所有推荐
  bannersReplace (ctx, data) {
    return fetch.bannersReplace(data).then(res => {
      return res.data
    })
  },
  // 根据条件查询推荐位列表
  bannerByExample (ctx, data) {
    return fetch.bannerByExample(data).then(res => {
      return res.data
    })
  },
  getActiveSetList (ctx, data) {
    return fetch.getActiveSetList(data).then(res => {
      return res.data
    })
  },
  bannerGoodsResources (ctx, data) {
    return fetch.bannerGoodsResources(data).then(res => {
      return res.data
    })
  },
  bannerNewsResouces (ctx, data) {
    return fetch.bannerNewsResouces(data).then(res => {
      return res.data
    })
  },
  promotionBannerUrl (ctx, data) {
    return fetch.promotionBannerUrl(data).then(res => {
      return res.data
    })
  },
  createLabels (ctx, data) {
    return fetch.createLabels(data).then(res => {
      return res.data
    })
  },
  getLabelsList (ctx, data) {
    return fetch.getLabelsList(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  labelListByName (ctx, data) {
    return fetch.labelListByName(data).then(res => {
      let result = getTotalNumber(res)
      return result
    })
  },
  editLabel (ctx, data) {
    return fetch.editLabel(data).then(res => {
      return res.data
    })
  },
  deleteLabel (ctx, id) {
    return fetch.deleteLabel(id).then(res => {
      return res.data
    })
  },
  getRelatedLabels (ctx, data) {
    return fetch.getRelatedLabels(data).then(res => {
      return res.data
    })
  },
  updateRelatedLabel (ctx, data) {
    return fetch.updateRelatedLabel(data).then(res => {
      return res.data
    })
  },
  deleteRelatedLabel (ctx, id) {
    return fetch.deleteRelatedLabel(id).then(res => {
      return res.data
    })
  },
  getVendorsOrganizations (ctx, data) {
    return fetch.getVendorsOrganizations(data).then(res => {
      let result = res.data
      return result
    })
  },
  newRefundmentReason (ctx, data) {
    return fetch.newRefundmentReason(data).then(res => {
      return res
    })
  },
  tagsObjects (ctx, data) {
    return fetch.tagsObjects(data).then(res => {
      return res.data
    })
  },
  promotionBannersPosition (ctx, data) {
    return fetch.promotionBannersPosition(data).then(res => {
      return res.data
    })
  },
  groupWithGoodsCount (ctx, data) {
    return fetch.groupWithGoodsCount(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.goodsGroupList(result.data)
      return result
    })
  },
  // 第三方供应商列表
  getVendorsList (ctx, data) {
    return fetch.getVendorsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallDatas.getVendorsList(result.data)
      return result
    })
  },
  setStick (ctx, id) {
    return fetch.setStick(id).then(res => {
      return res.data
    })
  },
  cancelStick (ctx, id) {
    return fetch.cancelStick(id).then(res => {
      return res.data
    })
  },
  updateNewsRanking (ctx, id) {
    return fetch.updateNewsRanking(id).then(res => {
      return res.data
    })
  },
  setNewsStick (ctx, id) {
    return fetch.setNewsStick(id).then(res => {
      return res.data
    })
  },
  cancelNewsStick (ctx, id) {
    return fetch.cancelNewsStick(id).then(res => {
      return res.data
    })
  },
  NewsRecommend (ctx, id) {
    return fetch.NewsRecommend(id).then(res => {
      return res.data
    })
  },
  NewsRecommendCancel (ctx, id) {
    return fetch.NewsRecommendCancel(id).then(res => {
      return res.data
    })
  },
  // 获取预约工单列表
  getOrderWorkList (ctx, data) {
    return fetch.getOrderWorkList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
        item.order_status = getEnumeration(item.status, workOrderType)
      })
      return result
    })
  },
  // 获取预约工单详情
  getOrderWorkDetail (ctx, data) {
    return fetch.getOrderWorkDetail(data).then(res => {
      res.data.createdDate_change = timeutils.format(res.data.createdDate, 'default')
      return res.data
    })
  },
  // 预约工单修改
  OrderWorkUpdate (ctx, data) {
    return fetch.OrderWorkUpdate(data).then(res => {
      return res.data
    })
  },
  // 获取预约工单导出历史列表
  getOrderWorkHistoryList (ctx, data) {
    return fetch.getOrderWorkHistoryList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  // 获取预约工单导出历史列表
  getCommodityDetail (ctx, data) {
    return fetch.getCommodityDetail(data).then(res => {
      let data = res.data.goodsData.specifications
      return data
    })
  },
  // 下载预约工单的导出历史
  HistoryListDownload (ctx, data) {
    return fetch.HistoryListDownload(data).then(res => {
      return res
    })
  },
  exportVendors (ctx, data) {
    return fetch.exportVendors(data).then(res => {
      let result = downloadFilename(res)
      return result
    })
  },
  // 搜索预约工单列表
  getOrderWorkSearch (ctx, data) {
    return fetch.getOrderWorkSearch(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  getVendorType (ctx) {
    return fetch.getVendorType().then(res => {
      return res.data
    })
  },
  // 获取意见反馈列表
  getFeedbackList (ctx, data) {
    return fetch.getFeedbackList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  }
}
